
function bindUri() {
//   const baseurl = 'https://signins.tsec-stg.com/authorize';
  const baseurl = 'https://signin.bindid-sandbox.io/authorize';
  const nonce = Math.floor(Math.random()*16777215).toString(16);
  const state = __st.cid;
  const clientId = '9a5d6129.e7547eb8.tid_f136ea20.bindid.io';
//   const redirectUri = 'https://demos.tsec-stg.com/_complete/acme';
  const redirectUri = window.location.href;
  
  let url = new URL(baseurl);
  url.searchParams.set('client_id', clientId);
  url.searchParams.set('redirect_uri', redirectUri);
  url.searchParams.set('nonce', nonce);
  url.searchParams.set('state', state);
  url.searchParams.set('scope', 'bindid_network_info openid');
  url.searchParams.set('response_type', 'code');
  return url.href;
}

async function deviceEvaluation() {
  const conf = localStorage.getItem('riskid_server');
  const serverPath = conf != null && conf != undefined ? conf : "https://riskid.dev/";
  const tenantId = 'mysecuredshop_tenant_id';
  const rdi = localStorage.getItem('rdi');
  //return fetch(`${serverPath}api/evaluate?tenantId=${tenantId}&deviceId=${rdi}`).then((value) => { return value.json() });
  return { data: 'fakeRecommendation' };
}

function shouldChallenge(evaluation) {
  const challengeme = localStorage.getItem('challengeme');
  const botRisk = evaluation?.detectionUnits?.bot_detection?.risk;
  return (!!challengeme && challengeme.length >0) || (botRisk > 0.7);
}
  
function isBindidRedirect() {
  const searchme = (new URL(window.location.href)).searchParams
  const code = searchme.get('code');
  return !!code && code.length > 0;
}

// Old version - before transaction data were added
// To be removed in a few weeks (from 6.02.2026)
// document.querySelector('#checkout').addEventListener('click', function(event) {
//   event.preventDefault();
//   console.log('clicked that checkout 11');
//   cookieStore.get('_shopify_y').then((shopifyToken) => {
//     window.myRiskID.triggerActionEvent('transaction', {correlationId: shopifyToken.value}).then((value) => {
//       deviceEvaluation().then((value) => {
//         if (shouldChallenge(value)) {
//           const challenge = bindUri();
//           console.log('I challenge thee with:' + challenge);
//           window.location.replace(challenge);
//         } else {
//           document.querySelector('#cart').submit();
//         }
//       }).catch(() => window.location.replace('/404'));
//     });
//   });
// });

  document.querySelector('#checkout').addEventListener('click', async function(event) {
    event.preventDefault();
    console.log('Checkout button clicked');

    try {
      const shopifyToken = await cookieStore.get('_shopify_y');

      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      const customerId = window.__st?.cid;
      const shop = window.Shopify?.shop;

      // Card products
      const products = cart.items.map(item => ({
        id: String(item.product_id),
        name: item.title,
        amount: item.quantity,
        price: item.price / 100
      }));

      const isReturningCustomer = !!customerId;

      const transactionData = {
        amount: cart.total_price / 100,
        currency: cart.currency,

        type: 'purchase',
        method: 'card',
        channelId: 'shopify_storefront',

        reason: `Checkout with ${cart.item_count} item(s)`,
        transactionDate: Date.now(),

        payer: {
          accountId: customerId ? String(customerId) : undefined,
          accountNumber: customerId ?? 'guest',
          name: customerId ? `Customer ${customerId}` : 'Guest',

          customerTier: isReturningCustomer ? 'registered' : 'guest',

          // No checkout data
          accountCountryCode: undefined,
          bankIdentifier: undefined,
          branchIdentifier: undefined,

          card: undefined,
          billingInfo: undefined
        },

        payee: {
          name: shop || 'Store',
          accountId: shop,
          accountNumber: shop,

          // No checkout data
          accountCountryCode: undefined,
          bankIdentifier: undefined,
          branchIdentifier: undefined,

          card: undefined
        },

        purchase: {
          totalItems: cart.item_count,

          products,
          // No checkout data
          shippingInfo: undefined
        },

        avs: undefined
      };

      const actionResponse = await window.myRiskID.triggerActionEvent('transaction', {
        correlationId: shopifyToken?.value,
        transactionData
      });

      const evaluation = await deviceEvaluation();

      if (shouldChallenge(evaluation)) {
        const challenge = bindUri();
        console.log('Challenge required:', challenge);
        window.location.replace(challenge);
      } else {
        console.log('No challenge needed, submitting cart');
        document.querySelector('#cart').submit();
      }

    } catch (error) {
      console.error('Error during checkout:', error);
      window.location.replace('/404');
    }
  });
  

if (isBindidRedirect()) {
  document.querySelector('#cart').submit();
}
